















import RolesList from '@/views/Admin/Roles/RoleList/RolesList.vue';
import AssignedPermission from '@/views/Admin/Roles/AssignedRoleList/AssignedPermission.vue';
import TabCard from '@/components/Tabs.vue';
import {Vue, Component} from 'vue-property-decorator';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
@Component({
  computed: {...mapGetters(['currentTab'])},
  methods: {...mapActions(['setCurrentTab'])},
  components: {
    RolesList,
    AssignedPermission,
    TabCard,
  },
})
export default class RolesPanel extends Vue {
  setCurrentTab: any;
  initialTab: String = this.$store.getters.currentTab.child || 'rolelist';
  tabs: Array<String> = ['rolelist', 'assignrolelist'];

  changeTab(activeTab) {
    this.setCurrentTab({parent: 'roles', child: activeTab});
  }
}
